import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AuthState } from "../models/auth";
import { removeToken } from "../utils/tokenHelper";

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      setToken: (token) => set({ token }),
      logout: (shouldNavigate: boolean = true) => {
        // Clear token from storage
        removeToken();
        
        // Clear state
        set({ user: null, token: null, isAuthenticated: false });
        
        if (shouldNavigate) {
          // Redirect to login page
          window.location.href = "/auth/login";
        }
      },
    }),
    {
      name: "auth-storage", // name of the item in localStorage
    },
  ),
);
